<template>
  <div :class="['themed-table-empty-state', customClass]">
    <!-- Loading State -->
    <div 
      v-if="loading" 
      class="themed-table-loading"
      role="status"
      aria-live="polite"
      aria-busy="true"
      aria-label="Loading table data"
    >
      <slot name="loading">
        <div class="themed-table-loading-content">
          <div class="themed-table-spinner" aria-hidden="true"></div>
          <p class="themed-table-loading-text">{{ loadingMessage }}</p>
        </div>
      </slot>
    </div>
    
    <!-- Empty State -->
    <div 
      v-else-if="isEmpty" 
      class="themed-table-empty"
      role="status"
      aria-live="polite"
      aria-label="No data available"
    >
      <slot name="empty-state">
        <div class="themed-table-empty-content">
          <theme-icon 
            :icon="icon" 
            :type="iconType" 
            classes="themed-table-empty-icon" 
            aria-hidden="true" 
          />
          <p class="themed-table-empty-text">{{ message }}</p>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import ThemeIcon from '../ThemeIcon.vue';

export default {
  name: 'TableEmpty',
  
  components: {
    ThemeIcon
  },
  
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    isEmpty: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'inbox'
    },
    iconType: {
      type: String,
      default: 'icons'
    },
    message: {
      type: String,
      default: 'No data available'
    },
    loadingMessage: {
      type: String,
      default: 'Loading...'
    },
    customClass: {
      type: String,
      default: ''
    }
  }
}
</script>
